import styles from './Why.module.css';

export default function Why() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Why MyPeopleDatabase?</h1>
        <p className={styles.subtitle}>
          Real-world scenarios where MyPeopleDatabase is the tool you wish you already had
        </p>

        <div className={styles.anarchyPanel}>
          <div className={styles.anarchyContent}>
            <h2 className={styles.anarchyTitle}>🔥 Stop the Contact Anarchy</h2>
            <p className={styles.anarchyDescription}>
              Tired of hunting through 5+ different address books for one phone number? Your
              contacts are scattered everywhere - phone, Gmail, Outlook, LinkedIn, business cards.
              <strong> The chaos ends here.</strong>
            </p>
            <a href="/consolidate" className={styles.anarchyButton}>
              End the Madness →
            </a>
          </div>
        </div>

        <div className={styles.scenariosContainer}>
          <div className={styles.scenario}>
            <h2>For Business Professionals</h2>
            <p>
              You've collected hundreds of business cards and contact details over the years.
              They're scattered across your phone, email, LinkedIn, and desk drawers. Finding the
              right contact when you need them is frustrating and time-consuming.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Import from multiple sources into one secure place, organize contacts into groups
                like "Leads" or "Conference 2024," and instantly filter and search when you need the
                right person.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Family Organizers</h2>
            <p>
              You're the one who keeps track of extended family addresses for holiday cards,
              birthdays, and family reunions. Every year you struggle with outdated addresses,
              forgotten birthdays, and trying to remember which cousins live where.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Create family groups with complete contact info, track birthdays, and store helpful
                details (kids' names, gift ideas, dietary restrictions). Update once, and have it
                everywhere you need it.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Social Connectors</h2>
            <p>
              You meet people constantly through various social circles and activities. You want to
              maintain these connections but find yourself forgetting details about people or losing
              track of how you met them.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Add rich notes about where you met, keep relationship context, and use the AI
                features (via the local MCP server) to quickly find and summarize what you already
                know before you reach out.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Privacy Conscious Users</h2>
            <p>
              You're concerned about big tech companies mining your contact list for data and
              insights. You want control over your relationships and personal network without giving
              away valuable information about your connections.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Own your data completely. Unlike social networks that treat your connections as
                their business asset, MyPeopleDatabase keeps your network yours. Even AI integration
                runs locally when you choose to enable it.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Legacy Preservers</h2>
            <p>
              You want to maintain a record of important people in your life, including those who
              have passed away, while keeping your active contact list current and usable.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Create special archives for contacts who have passed away, preserving their
                information and your memories while keeping your active contact list clean and
                organized.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Group Coordinators</h2>
            <p>
              You're coordinating people across a family, team, club, or community. You need the
              right contact info shared with the right people, without blasting your entire address
              book into yet another group chat.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Organize contacts into groups, then use private sharing to share the right details
                with the right group—without creating a centralized social graph.
              </p>
            </div>
          </div>

          <div className={styles.scenario}>
            <h2>For Networkers & Creators</h2>
            <p>
              You want a single link you can share that looks professional, is easy to update, and
              doesn't depend on a social platform staying friendly forever.
            </p>
            <div className={styles.solutionBox}>
              <h3>MyPeopleDatabase Solution</h3>
              <p>
                Publish an MPD ID Page at a clean URL like /profile/your-id. Share it on business
                cards, email signatures, and socials—and control what people see.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.conclusionBox}>
          <h2>Your Data. Your Relationships. Your Control.</h2>
          <p>
            MyPeopleDatabase was created with a fundamental belief: your personal relationships are
            valuable, and you should own them completely. We provide the tools to organize,
            maintain, and leverage your network while ensuring you retain full ownership and
            control.
          </p>
          <p>Ready to take control of your contact management?</p>
          <div className={styles.ctaButtons}>
            <a href="/buy" className={styles.ctaButton}>
              Get Started Now
            </a>
            <a href="/features" className={styles.ctaButtonSecondary}>
              Explore Features
            </a>
            <a href="/features-ai" className={styles.ctaButtonSecondary}>
              See AI Features
            </a>
            <a href="/mpd-id" className={styles.ctaButtonSecondary}>
              Learn about MPD ID Page
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
